import { AfterViewInit, ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { CollegeInfo } from '../../../services/application/application.service';
import { MatSelectChange } from '@angular/material/select';
import { MatOptionSelectionChange } from '@angular/material';


@Component({
    selector: 'app-tags',
    templateUrl: './tags.component.html',
    styleUrls: ['./tags.component.scss'],
})
export class TagsComponent implements OnInit, AfterViewInit {
    @Input() tagData: any[];
    @Input() tagType: string = TagTypes.College;
    @Input() options: Tag[];
    @Input() isVertical: boolean = true;
    @Input() showAddLabel: boolean = false;
    @Input() allowEdit: boolean = true;
    @Input() canRemove: boolean = true;
    @Input() control: FormControl = new FormControl();
    @Output() addTag = new EventEmitter<number>();
    @Output() updateTags = new EventEmitter<number[]>();
    @Output() removeTag = new EventEmitter<number>();

    selectedTags: Tag[] | null = null;
    selectedTagIDs: number[] | null = null;

    constructor( private cd: ChangeDetectorRef) {
        this.tagData = [];
        this.options = [];
    }

    ngOnInit(): void {
        const tags = this.mapTags(this.tagType, this.tagData);
        this.selectedTags = tags;
        this.selectedTagIDs = this.tagData.map(x => x.CollegeID);
        this.control = new FormControl(tags);
        // console.log('control', {
        //     tagData: this.tagData,
        //     control: this.control,
        //     controlValue: this.control.value,
        //     selectedTags: this.selectedTags
        // })
        this.cd.detectChanges();
    }

    ngAfterViewInit() {
        this.cd.detectChanges();
    }

    cssClass(styleClass: string): string {
        return 'chip chip-' + styleClass.trim().replace(/\s+/g, '-').toLowerCase();
    }

    // Compare function will autmatically compare the FormControl values with the list of categories
    compareFn(c1: Tag, c2: Tag) {
        return c1 && c2 && c1.id === c2.id;
    }

    compare(c1: { name: string }, c2: { name: string }) {
        return c1 && c2 && c1.name === c2.name;
    }

    mapTags(type: string, data: any): Tag[] | null {
        switch (type) {
            case TagTypes.College:
                const mappedData = data.map((d: CollegeInfo) => new Tag(d.CollegeName, d.CollegeID, d.Active));
                return mappedData
            default:
                return null;
        }
    }

    onTagRemoved(tag: Tag): void {
        const controlValue = this.control.value as Tag[];

        if (this.control.disabled) return;

        const index = controlValue.indexOf(tag);

        if (index >= 0) {
            controlValue.splice(index, 1);
        }

        this.control.setValue(controlValue); // To trigger change detection
        // const data = this.TransformTagsToArrayOfCollegeIDs(controlValue)
        // this.updateTags.emit(data);
        this.removeTag.emit(tag.id);
    }

    TransformTagsToArrayOfCollegeIDs(tagArry: Tag[]) {
        return tagArry.map(x => x.id);
    }
    
    UpdateTag(event: MatOptionSelectionChange): void {
        if (!event.isUserInput) {
            return;
        }
        // console.log('event', { event: event, selected: event.source.selected, control: this.control } );

        event.source.selected
            ? this.addTag.emit(event.source.value.id)
            : this.removeTag.emit(event.source.value.id)
        ;
        
        // const data = this.TransformTagsToArrayOfCollegeIDs(event.value as Tag[])
        // this.updateTags.emit(data);

        // const tags = this.mapTags(this.tagType, this.tagData);
        // if (event.option.selected) {
        //     const option = this.tagData.filter(x => x.id == event.option.value.id)[0];
        //     this.selectedTags?.push(option);
        // } else {
        //     const tags = this.mapTags(this.tagType, this.tagData);
        //     this.selectedTags = (tags || []).filter(x => x.id != event.option.value.id);
        // }

        // event.option.selected
        //     ? this.addTag.emit(event.option.value)
        //     : this.removeTag.emit(event.option.value)
        // ;
    }

}

export enum TagTypes {
    College = 'college',
}

export class Tag {
    name: string;
    id: number;
    active?: boolean | null;

    constructor(name: string, id: number, active: boolean | null = null) {
        this.name = name;
        this.id = id;
        this.active = active;
    }
}



// WEBPACK FOOTER //
// ./src/app/ui/tags/tags.component.ts